import classNames from 'classnames'

import { IconNG } from '../../Icon'
import { QA_NAME_RATING } from '../Rating'

import * as styles from './RatingItem.module.css'

import StarEmptyIcon from '../../../icons/star.svg'
import StarFilledIcon from '../../../icons/star-filled.svg'

function RatingItem({
  disabled,
  filled,
  itemSize,
  themed,
  value,
  onClickItem,
  onHover,
}) {
  const iconClassName = classNames(styles.icon, {
    [styles.hoverItem]: !!onClickItem && !disabled,
    [styles.themed]: themed,
  })

  function handleClick() {
    if (disabled) {
      return
    }

    onClickItem?.(value)
  }

  function handleMouseEnter() {
    if (!disabled) {
      onHover?.(value)
    }
  }

  return (
    <IconNG
      Icon={filled ? StarFilledIcon : StarEmptyIcon}
      className={iconClassName}
      qaName={QA_NAME_RATING}
      size={itemSize}
      onClick={handleClick}
      onMouseEnter={handleMouseEnter}
    />
  )
}

export default RatingItem
